<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="orange"></v-tabs-slider>
            <v-tab href="#tab-message">
              <span class="text-md-h6">Sambutan Direktur</span>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-message">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12" class="text-justify">
                        <img
                          :src="require('../assets/dir-img.jpeg')"
                          alt="Direktur Politeknik Negeri Bali"
                          class="float-left img-native pr-md-10 pb-5"
                          width="500px">
                        <p>
                          Puji syukur kehadapan Ida Sang Hyang Widi Wasa saya panjatkan, karena atas segala rahmat dan karuniaNya kami segenap sivitas akademika Politeknik Negeri Bali (PNB) dapat menunaikan kewajiban turut berkontribusi dalam meningkatkan peran PNB untuk mewujudkan visi dan misi sebagai Lembaga pendidikan Vokasi Terdepan yang menghasilkan lulusan yang Profesional yang memiliki daya saing Internasional pada Tahun 2025.
                        </p>
                        <p>
                          Politeknik Negeri Bali senantiasa berkeinginan untuk terus menguatkan peran untuk ikut berkontribusi untuk menghasilkan Sumber Daya Manusia yang kompeten, profesional dan yang mampu meningkatkan Daya saing Bangsa (Nation's Competitiveness). Beberapa program kegiatan yang dirancang untuk mencapai hal tersebut adalah dengan melakukan kemitraan dengan Industri, Dunia Usaha dan Dunia Kerja (IDUKA). Bagi Lembaga Pendidikan Vokasi seperti Politeknik Negeri Bali, Kemitraan (partnership) merupakan kegiatan yang sangat sangat strategis sehingga terjadi kemitraan yang saling memberi manfaat (mutual benefits) dalam jangka panjang. Kehadiran dunia usaha dan Dunia Industri tersebut akan memberi banyak penguatan bagi PNB. Penguatan tersebut bisa berupa keterlibatan IDUKA dalam penyusunan kurikulum, program magang, dan program pendampingan industri (Matching-Up & Pairing-Up) yang telah dilakukan dengan baik secara bersama antara PNB dan IDUKA. Saya sangat meyakini, jika hal tersebut terus dilakukan secara konsisten dan berkelanjutan dengan penuh komitmen, maka tujuan dari program 'LINK & MATCH' dan 'Pernikahan Massal'  akan dapat dicapai, yaitu dihasilkannya  SDM yang sesuai dengan kebutuhan Industri.
                        </p>
                        <p>
                          Dalam Rangka penguatan Kemitraan dengan Industri dan alumni PNB, kami menyiapkan program Career Center yang dihasilkan dari Program Hibah Bursa Kerja Khusus (BKK) yang berhasil dimenangkan oleh PNB dari Direktorat Kemitraan dan Penyelesaran DUDI (MITRAS DUDI) Kementerian Pendidikan dan Kebudayaan. Program ini akan ditujukan agar para alumni PNB dapat terus terjalin komunikasinya dengan PNB untuk mengembangkan karir sebagai SDM yang menjadi andalan industri. Pemberian informasi yang 'Terbaru' dari Mitra PNB akan memberi banyak peluang para alumni PNB untuk memenangkan persaingan atas suatu posisi pekerjaan atau jabatan yang ada di Industri. Dan, untuk menjada komunikasi antara PNB dan Mitra PNB, kami menyiapkan website khusus untuk Career Center ini sehingga akan dapat berinterasi kapanpuan dan dimanapun.
                        </p>
                        <p>
                          Semoga Program Bursa Kerja Khusus dan Career Center ini akan memberi banyak manfaat kepada PNB, alumni PNB dan Mitra industri PNB untuk terus berkolaborasi menyiapkan sumber daya manusia yang Unggul, Kompeten, Profesinal dan memiliki daya saing internasional. Dalam kesempatan ini, saya sebagai Direktur PNB menyampaikan Ucapan terimakasih dan apresiasi yang setinggi tingginya kepada Bapak Direktur Kemitraan dan Penyelerasan DUDI KemdikBud, dan juga kepada Semua Mitra PNB yang penuh dedikasi dan komitmen memberi dukungan sehingga tercapainya kemitraan yang sangat Kuat.
                        </p>
                        <p>
                          Badung, 27 Nopember 2020<br/>
                          Direktur Politeknik Negeri Bali
                        </p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.jeniskerja"
      max-width="600px"
      v-if="dmodaldata.jeniskerja">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Update jenis pekerjaan</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <alertsp :alertdata="alertupdate"></alertsp>
            <v-form
              @submit.prevent="submitUpdate"
              ref="formupdatejeniskerja"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center" no-gutters>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.jeniskerja.nama_kerja"
                        :rules="[rules.required]"
                        label="Nama"
                        name="nama"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        v-model="dmodaldata.jeniskerja.deskripsi_kerja"
                        auto-grow
                        label="Deskripsi jenis pekerjaan"
                        rows="1">
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="liststatus"
                        name="statuskerja"
                        v-model="dmodaldata.jeniskerja.status_kerja"
                        label="Status">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-btn
                        large
                        color="error"
                        class="mr-4 mt-5"
                        @click="closeDmodal('jeniskerja')">
                        Cancel
                      </v-btn>
                      <v-btn
                        large
                        :disabled="!formupdate.valid"
                        color="success"
                        class="mr-4 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'About',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    // this.getJeniskerja();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getJeniskerja() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddjeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.addjeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddjeniskerja.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'pekerjaan "' + resdata.data + '" berhasil ditambahkan!';
                  this.getJeniskerja();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jeniskerja') {
        this.dmodal.jeniskerja = false;
      } else {
        this.dmodal.jeniskerja = false;
      }
    },
    editJeniskerja(item) {
      this.dmodal.jeniskerja = true;
      this.dmodaldata.jeniskerja = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.dmodaldata.jeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.jeniskerja.nama_kerja + '" berhasil diubah!';
                  this.getJeniskerja();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
